import { PropsWithChildren } from 'react';
import { ModuleTileStylesProps, useModuleTileStyles } from './module-tile.styles';

export type ModuleTileComponentProps = PropsWithChildren<
  ModuleTileStylesProps & {
    title: string;
    onTitleClick?: () => void;
  }
>;

export function ModuleTile({
  title,
  pixelDimensions2D,
  maxModuleHeight,
  onTitleClick,
  children
}: ModuleTileComponentProps) {
  const classes = useModuleTileStyles({ pixelDimensions2D, maxModuleHeight });
  return (
    <div className={classes.root}>
      <div
        className={classes.title}
        onClick={onTitleClick}
        style={onTitleClick ? { cursor: 'pointer', userSelect: 'none' } : undefined}
      >
        {title}
      </div>
      <div className={classes.deliveryContainerTiles}>{children}</div>
    </div>
  );
}
